/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateVolunteerRequest
 */
export interface UpdateVolunteerRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    salutation: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    houseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateVolunteerRequest
     */
    remarks: string | null;
}

/**
 * Check if a given object implements the UpdateVolunteerRequest interface.
 */
export function instanceOfUpdateVolunteerRequest(value: object): value is UpdateVolunteerRequest {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('salutation' in value) || value['salutation'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('remarks' in value) || value['remarks'] === undefined) return false;
    return true;
}

export function UpdateVolunteerRequestFromJSON(json: any): UpdateVolunteerRequest {
    return UpdateVolunteerRequestFromJSONTyped(json, false);
}

export function UpdateVolunteerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateVolunteerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'salutation': json['salutation'],
        'title': json['title'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'email': json['email'],
        'phone': json['phone'],
        'remarks': json['remarks'],
    };
}

export function UpdateVolunteerRequestToJSON(json: any): UpdateVolunteerRequest {
    return UpdateVolunteerRequestToJSONTyped(json, false);
}

export function UpdateVolunteerRequestToJSONTyped(value?: UpdateVolunteerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'salutation': value['salutation'],
        'title': value['title'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'email': value['email'],
        'phone': value['phone'],
        'remarks': value['remarks'],
    };
}

